// z index order of the different map layers
export const W3W_ZINDEX = -2;
export const ERA_ZINDEX = -1;
export const HISTORIC_LOC_ZINDEX = 1;
export const MOST_RECENT_LOC_ZINDEX = 2;
export const DYNAMIC_LAYER_ZINDEX = 3;
export const STATIC_LAYER_ZINDEX = 4;
